var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.221 12.124L11.375 4.41H12.257L12.089 12.138C12.089 12.474 12.0003 12.782 11.823 13.062C11.655 13.3513 11.4263 13.58 11.137 13.748C10.8477 13.916 10.535 14 10.199 14H3.871C3.535 14 3.22233 13.916 2.933 13.748C2.64367 13.58 2.41033 13.3513 2.233 13.062C2.065 12.782 1.981 12.474 1.981 12.138L1.827 4.41H2.695L2.849 12.124C2.85833 12.3947 2.961 12.628 3.157 12.824C3.36233 13.0293 3.60033 13.132 3.871 13.132H10.199C10.4697 13.132 10.703 13.0293 10.899 12.824C11.1043 12.628 11.2117 12.3947 11.221 12.124ZM1.323 1.75H12.691C12.8123 1.75 12.915 1.792 12.999 1.876C13.083 1.96 13.125 2.06267 13.125 2.184C13.125 2.30533 13.083 2.408 12.999 2.492C12.915 2.576 12.8123 2.618 12.691 2.618H1.323C1.20167 2.618 1.09433 2.576 1.001 2.492C0.917 2.408 0.875 2.30533 0.875 2.184C0.875 2.06267 0.917 1.96 1.001 1.876C1.09433 1.792 1.20167 1.75 1.323 1.75ZM9.625 0.868H4.375C4.25367 0.868 4.151 0.826 4.067 0.742C3.983 0.658 3.941 0.555333 3.941 0.433999C3.941 0.312667 3.983 0.21 4.067 0.126C4.151 0.042 4.25367 0 4.375 0H9.625C9.74633 0 9.849 0.042 9.933 0.126C10.0263 0.21 10.073 0.312667 10.073 0.433999C10.073 0.555333 10.0263 0.658 9.933 0.742C9.849 0.826 9.74633 0.868 9.625 0.868Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.bc65939eb19e0f98f5f959f79befa4f0.svg";
export { ForwardRef as ReactComponent };